import React from "react";
import PropTypes from "prop-types";
import cl from "classnames";
import classes from "./styles.module.scss";
import useMaxHeight from "./useMaxHeight";

const transformProp = (function () {
  if (!document) return;
  const testEl = document.createElement("div");
  if (testEl.style.transform == null) {
    const vendors = ["Webkit", "Moz", "ms"];
    for (const vendor of vendors) {
      if (testEl.style[vendor + "Transform"] !== undefined) {
        return vendor + "Transform";
      }
    }
  }

  return "transform";
})();

const StageContainer = ({ stage, className, paddingRem, children }) => {
  let transform = `translateX(-${stage * 100}%)`;
  if (paddingRem) transform += ` translateX(-${paddingRem * stage}rem)`;
  const ref = useMaxHeight(stage);

  return (
    <div
      ref={ref}
      className={cl(classes.StageContainer, className)}
      style={{ [transformProp]: transform }}
    >
      {children}
    </div>
  );
};

StageContainer.propTypes = {
  stage: PropTypes.number.isRequired,
  children: PropTypes.node.isRequired,
  paddingRem: PropTypes.number,
  className: PropTypes.string,
};

export default StageContainer;
